import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "../assets/styles/PageStyles.scss";

const NotFound: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="page-container">
      <Helmet>
        <title>Page Not Found | Goal Guru</title>
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content="Page Not Found | Goal Guru" />
        <meta
          property="og:description"
          content="The page you’re looking for doesn’t exist (or was moved)."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://goalguru.live/og/default.svg"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Page Not Found | Goal Guru" />
        <meta
          name="twitter:description"
          content="The page you’re looking for doesn’t exist (or was moved)."
        />
        <meta
          name="twitter:image"
          content="https://goalguru.live/og/default.svg"
        />
      </Helmet>

      <header>
        <h1>Page Not Found</h1>
        <p className="subtitle">
          The page you’re looking for doesn’t exist (or was moved).
        </p>
      </header>

      <p>
        Go back to the <Link to="/">homepage</Link>, browse the{" "}
        <Link to="/features/">features</Link>, or read the{" "}
        <Link to="/blog/">blog</Link>.
      </p>
    </div>
  );
};

export default NotFound;
